import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'dateFieldPlaceholderMessage'
  | 'calendarAriaLabel'
  | 'clearDatePickerAriaLabel'
  | 'nextMonthAriaLabel'
  | 'previousMonthAriaLabel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  dateFieldPlaceholderMessage: {
    id: 'boxFileRequest.dateField.placeholderMessage',
    description: 'Placeholder for date field',
    defaultMessage: 'Select a date',
  },
  calendarAriaLabel: {
    id: 'boxFileRequest.dateField.calendarAriaLabel',
    description:
      'The aria label of the calendar icon within datepicker input which indicates to open the calendar',
    defaultMessage: 'Select a date',
  },
  clearDatePickerAriaLabel: {
    id: 'boxFileRequest.dateField.clearDatePickerAriaLabel',
    description:
      'The aria label of the cross icon within datepicker input which indicates clear the input',
    defaultMessage: 'Clear the selected date',
  },
  nextMonthAriaLabel: {
    id: 'boxFileRequest.dateField.nextMonthAriaLabel',
    description:
      'The aria label of the right-arrow icon in calendar which indicates switch to next month',
    defaultMessage: 'Switch to next month',
  },
  previousMonthAriaLabel: {
    id: 'boxFileRequest.dateField.previousMonthAriaLabel',
    description:
      'The aria label of the left-arrow icon in calendar which indicates switch to previous month',
    defaultMessage: 'Switch to previous month',
  },
});

export default messages;
